var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFunction48Filled = function SvgIconFunction48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3C14.79 7.3 7.3 14.79 7.3 24c0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm-1 16.4h-4.3V32h-3.4V19.6c0-2.92 2.38-5.3 5.3-5.3H24v3.4h-3.4a1.9 1.9 0 0 0-1.9 1.9v.7H23v3.4Zm11.2 5.9L31.8 32 29 29.2 26.2 32l-2.4-2.4 2.8-2.8-2.8-2.8 2.4-2.4 2.8 2.8 2.8-2.8 2.4 2.4-2.8 2.8 2.8 2.8Z",
    fill: "current"
  })));
};
export default SvgIconFunction48Filled;